import React from 'react';
import * as cn from 'classnames';
import PropTypes from 'prop-types';

function Icon({ type, icon, className }) {
  return (
    <i
      className={cn(`${type}-${icon || 'devicon-plain'}`, {
        [className]: !!className,
      })}
    ></i>
  );
}

Icon.defaultProps = {
  type: 'devicon',
  icon: '',
  className: '',
};

Icon.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
};

export default React.memo(Icon);
